// extracted by mini-css-extract-plugin
export default {"user-message":"styles_user-message__p3jRg"};